module.exports = __webpack_public_path__ + "img/SHIFT.560df6a1.svg";